import { defineStore } from 'pinia';
import state from './state.js';
import actions from './actions.js';
import getters from './getters.js';

export const useCalendarStore = defineStore('calendar', {
    state() {
        return state;
    },
    getters,
    actions,
});
